import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LicenseViewModel } from "@api/web-api-client";

export interface ILicenseState {
    license?: LicenseViewModel;
}

const initialState: ILicenseState = {
    license: undefined,
};

export const licenseSlice = createSlice({
    name: "license",
    initialState: initialState,
    reducers: {
        setLicense: (state, action: PayloadAction<LicenseViewModel>) => {
            state.license = action.payload;
        },
    },
});

export const { setLicense } = licenseSlice.actions;

export default licenseSlice.reducer;
